// extracted by mini-css-extract-plugin
export default {"wrapper":"c1-z","play":"d1-z"};